module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Supportive-Relationships",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M60,55 C55.127024,55 13.3021113,55 10,55 C10,43.8366699 14.1764427,34.2923521 24.1662077,30.4365191 C23.1158447,29.284668 20.0156657,25.7830811 20.0156657,20.0223796 C20.0156657,13.3143916 25.6017125,5 35,5 C43.7435452,5 49.9338786,12.3539225 49.9338786,20.0223796 C49.9338786,26.9734701 45.8765671,30 45.8765671,30.4549123 C55.8335853,34.3226378 60,43.8543791 60,55 Z M45,55 C43.0508096,55 26.3208445,55 25,55 C25,50.534668 26.6705771,46.7169408 30.6664831,45.1746076 C30.2463379,44.7138672 29.0062663,43.3132324 29.0062663,41.0089518 C29.0062663,38.3257566 31.240685,35 35,35 C38.4974181,35 40.9735514,37.941569 40.9735514,41.0089518 C40.9735514,43.789388 39.3506268,45 39.3506268,45.1819649 C43.3334341,46.7290551 45,50.5417516 45,55 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e488130"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/supportive_relationships.vue
// module id = 654
// module chunks = 1